import ApiCrud from "./api-crud";

class ContactoService extends ApiCrud {
  resource = "contactos";
  primaryKey = "idcontacto";
}

export default new ContactoService();
